// css
import 'react-datepicker/dist/react-datepicker.css';

// styles
import { labelStyles } from 'styles';

// constants
import { arrowImage } from 'constants/images';

// libraries
import { type CSSProperties } from 'react';
import styled, { css } from 'styled-components';

interface ContainerProps extends CSSProperties {
  $labelPosition: string;
}

export const StyledDatepicker = styled.div<ContainerProps>`
  ${({ $labelPosition }) =>
    $labelPosition === 'left' &&
    css`
      ${labelStyles}
    `}

  & * :hover {
    cursor: pointer;
  }
  /* margin-bottom: 20px; */
  .dp-label {
    display: flex;
    align-items: center;
    position: relative;

    span {
      width: 10px;
      height: 5px;
      position: relative;
      top: -4px;
      left: 2px;
    }
  }

  /* required */
  .required {
    p {
      left: 15px;
      z-index: 1;
    }
  }

  .dp-label {
    display: flex;
    align-items: center;
    position: relative;

    span {
      width: 10px;
      height: 5px;
      position: relative;
      top: -4px;
      left: 2px;
      padding-left: 0 !important;
    }
  }

  span {
    font-weight: 600;
    display: inline-block;
    margin-bottom: 7px;
    padding-left: 8px;
  }

  .datePickerWrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${(props) => (props.width ? props.width : null)};
    height: 40px;
    border-radius: 4px;
    border: 1px solid var(--color-pale-gray);
    box-sizing: border-box;
    background-color: var(--color-white);
    cursor: pointer;
    overflow: hidden;

    > label {
      > img {
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
        user-select: none;
        pointer-events: none;
      }
    }
  }

  .react-datepicker-wrapper {
    width: 100%;
  }
  .datepicker {
    /* padding-left: 22px; */
    border: none;
    width: inherit;
    min-height: 34px;
    background-color: var(--color-white);
    border-radius: 4px;
    &:focus {
      outline: none;
    }
    &:hover {
      //box-shadow: 0px 0px 0px 3px var(--color-off-white);
    }
    &:active {
      border-color: var(--color-pale-gray);
    }
    &:disabled {
      background-color: var(--color-off-white);
      color: var(--color-medium-gray);
      border: 1px solid var(--color-pale-gray);
      cursor: not-allowed;
    }
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    border-radius: 100%;
    background-color: var(--color-pale-gray) !important;
    color: var(--color-white);
  }

  .react-datepicker__day-names,
  .react-datepicker__week {
    display: flex;
    justify-content: space-evenly;
  }
  .react-datepicker__day:hover {
    border-radius: 100%;
    color: var(--color-pale-gray);
    background-color: var(--color-off-white);
  }
  .react-datepicker__header {
    background-color: var(--color-off-white);

    .react-datepicker__header__dropdown {
      padding: 16px 0px 5px;
    }
  }
  .react-datepicker__navigation-icon--previous::before,
  .react-datepicker__navigation-icon--next::before,
  .react-datepicker__month-year-read-view--down-arrow {
    width: 19px;
    height: 19px;
    border: none;
    transform: none;
  }
  .react-datepicker__navigation-icon--previous::before {
    background-image: url(${arrowImage.arrowPrev});
  }
  .react-datepicker__navigation-icon--next::before {
    background-image: url(${arrowImage.arrowNext});
  }
  .react-datepicker__month-year-read-view--down-arrow {
    right: -24px;
    top: 3px;
    background-image: url(${arrowImage.arrowDropDown});
  }
`;

export const StyledDoubleDatePicker = styled(StyledDatepicker)`
  display: flex;
  align-items: center;
  margin-bottom: 0;
  .during {
    display: inline-flex;
    margin: 0 8px;
    color: var(--color-medium-gray);
    font-size: 14px;
  }
  .react-datepicker-wrapper {
    width: 136px;
    height: 100%;
  }
  .datePickerWrapper {
    position: relative;
    border-color: var(--color-pale-gray);
    border-radius: 6px;
    &:hover {
      box-shadow: 0 0 0 3px var(--color-off-white);
    }
    //달력아이콘
    .icon {
      position: absolute;
      top: 50%;
      right: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      margin-top: -12px;
    }
  }
  .datepicker {
    height: 38px;
    padding: 11px 32px 11px 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: var(--color-medium-gray);
    cursor: pointer;
  }

  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    background-color: var(--color-pale-gray);
    border-radius: 100%;
  }
`;
